import { CheckCircle, Error, Info, Warning } from "@mui/icons-material";
import { Button, Modal, Paper, Stack, Typography } from "@mui/material";
import { Box, bgcolor, useTheme } from "@mui/system";
import useStyles from "./styles";

export default function InternoModalDeleteCliente(params) {
	const theme = useTheme();
	const styles = useStyles(theme);

	const {
		openDeleteModal = false,
		deleteLoad = false,
		setOpenDeleteModal = () => {},
		execute = () => {},
		severity = "",
		contentText = "",
		confirmText = "",
	} = params;

	return (
		<Modal
			open={openDeleteModal}
			onClose={() => {
				setOpenDeleteModal(false);
			}}
			sx={styles.modal}
		>
			<Paper sx={styles.paper}>
				<Box sx={styles.boxPaper}>
					<Box
						// tipos de modal detele 1: error, 2: warn, 3: info, 4: success
						sx={{
							bgcolor:
								severity == "error"
									? "chip.main.pending"
									: severity == "warning"
									? "warning.main"
									: severity == "info"
									? "chip.main.waitingReview"
									: severity == "success"
									? "success.main"
									: "chip.main.pending",

							display: "flex",
							flexDirection: "column",
							alignItems: "center",
							gap: 1,
							justifyContent: "center",
							height: "200px",
							borderTopLeftRadius: "12px",
							borderTopRightRadius: "12px",
						}}
					>
						{severity == "warning" ? (
							<Warning sx={styles.headerIcon} />
						) : severity == "info" ? (
							<Info sx={styles.headerIcon} />
						) : severity == "success" ? (
							<CheckCircle sx={styles.headerIcon} />
						) : (
							<Error sx={styles.headerIcon} />
						)}

						<Typography variant="title" sx={styles.headerTitle}>
							Atenção!
						</Typography>
					</Box>
					<Box sx={styles.contentBox}>
						<Box sx={styles.textBox}>
							<Typography variant="mySubtitle">
								{contentText
									? contentText
									: "Se você prosseguir com a operação, o item será deletado permanentemente!"}
							</Typography>
						</Box>

						<Stack
							direction={"row"}
							gap={16}
							justifyContent={"center"}
							width={"100%"}
						>
							<Button
								onClick={() => {
									setOpenDeleteModal(false);
								}}
								variant="outlined"
								sx={{
									color: theme.palette.text.main,
									borderColor: theme.palette.text.main,
								}}
							>
								Cancelar
							</Button>
							<Button
								onClick={execute}
								disabled={deleteLoad}
								variant="contained"
								sx={{
									bgcolor:
										severity == "error"
											? "chip.main.pending"
											: severity == "warning"
											? "warning.main"
											: severity == "info"
											? "chip.main.waitingReview"
											: severity == "success"
											? "success.main"
											: "chip.main.pending",
									":hover": {
										bgcolor:
											severity == "error"
												? `${theme.palette.chip.colorText.critical}`
												: severity == "warning"
												? `${theme.palette.chip.colorText.high}`
												: severity == "info"
												? `${theme.palette.chip.colorText.medium}`
												: severity == "success"
												? `${theme.palette.chip.colorText.success}`
												: `${theme.palette.chip.colorText.critical}`,
									},
									color: theme.palette.white.main,
								}}
							>
								{confirmText ? confirmText : "CONFIRMAR"}
							</Button>
						</Stack>
					</Box>
				</Box>
			</Paper>
		</Modal>
	);
}
